import { Illustration, Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

export const AssetNotFound: React.FC = () => {
  return (
    <VStack space={Spacing['inline.quarck']} alignItems={'center'} py={Spacing['stack.xxs']}>
      <Illustration name="NotFoundIllustration" testID="illustration-not-found" />
      <Text fontSize="md" color="neutral.black" variant="semibold" mt={Spacing['inset.nano']}>
        Nenhum resultado corresponde à sua pesquisa
      </Text>
      <Text
        textAlign="center"
        color="neutral.black"
        variant="regular"
        fontSize="md"
        px={Spacing['inline.nano']}>
        Por favor, verifique o campo informado e tente novamente.
      </Text>
    </VStack>
  );
};
